/** @jsxRuntime classic */
/** @jsx jsx */
import type { ReactNode } from 'react';
import type { MessageDescriptor } from 'react-intl';

import { jsx } from '@atlaskit/css';
import SmartLinkIcon from '@atlaskit/icon/core/smart-link';
import { token } from '@atlaskit/tokens';

import { ContentIcon } from '@confluence/icons/entry-points/ContentIcon.ts';

import { recentWorkMessages } from '../recentWorkMessages.ts';

const getContentIconColor = (type?: string, subType?: string | null) => {
	if ((type === 'page' && subType === 'live') || type === 'liveDoc') {
		return token('color.icon.accent.magenta');
	}
	if (type === 'page' || type === 'blogpost') {
		return token('color.icon.accent.blue');
	}
	if (type === 'whiteboard' || type === 'slide') {
		return token('color.icon.accent.teal');
	}
	if (type === 'database') {
		return token('color.icon.accent.purple');
	}
	if (type === 'embed') {
		return token('color.icon.accent.gray');
	}
	return undefined;
};

export const getContentTypeMessage = (
	type: string | undefined,
	subType: string | null | undefined,
): MessageDescriptor | undefined => {
	if ((type === 'page' && subType === 'live') || type === 'liveDoc') {
		return recentWorkMessages.contentTypeLiveDoc;
	}
	const messages: Record<string, MessageDescriptor> = {
		page: recentWorkMessages.contentTypePage,
		blogpost: recentWorkMessages.contentTypeBlogPost,
		whiteboard: recentWorkMessages.contentTypeWhiteboard,
		database: recentWorkMessages.contentTypeDatabase,
		embed: recentWorkMessages.contentTypeSmartLink,
		slide: recentWorkMessages.contentTypeSlide,
	};
	return type ? messages[type] : undefined;
};

export const getContentIcon = (type?: string, subType?: string | null, emoji?: string): ReactNode =>
	emoji ? (
		<ContentIcon type={type || ''} subType={subType || ''} emoji={emoji} />
	) : type === 'embed' ? (
		<SmartLinkIcon
			label=""
			color={getContentIconColor(type, subType)}
			testId="recent-work-smart-link-icon"
		/>
	) : (
		<ContentIcon
			type={type || ''}
			subType={subType || ''}
			color={getContentIconColor(type, subType)}
		/>
	);
